import React from "react"
import { CreateRoleForm } from "@/components/forms"
import type { CreateOrganizationRoleStepProps } from "./CreateOrganizationRoleStep.types"

export const CreateOrganizationRoleStep: React.FunctionComponent<
  CreateOrganizationRoleStepProps
> = ({ onSuccess }) => {
  return <CreateRoleForm onSuccess={onSuccess} />
}
